const datoraErrorKeys = { empty: 'discountErrorEmpty', double: 'discountErrorDouble', failed: 'discountErrorFailed', invalid: 'discountErrorInvalid' };

const truncate = (str, len = 10) => str.length > len ? str.substring(0, len) + '...' : str;

// DATORACODE - A/B-Test (CFSN-603): true only when the hide-toggle is on, auto-discount is
// enabled, and the active code matches the configured auto_discount_code (case-insensitive,
// whitespace-trimmed) — regardless of how the code was applied (auto or manually entered).
function shouldHideAutoCode(activeCode) {
  const ts = window.themeSettings || {};
  const tv = (window.themeVariables && window.themeVariables.settings) || {};
  if (!ts.hideAutoDiscountCode || !tv.autoDiscountEnabled || !tv.autoDiscountCode) return false;
  if (!activeCode) return false;
  return activeCode.trim().toUpperCase() === String(tv.autoDiscountCode).trim().toUpperCase();
}

// Shopify-kompatible Preisformatierung
function shopifyFormatCurrency(cents, formatString) {
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return '0';
    const numString = (number / 100.0).toFixed(precision);
    const parts = numString.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  return formatString.replace(placeholderRegex, (match, placeholder) => {
    switch (placeholder) {
      case 'amount':
        return formatWithDelimiters(cents, 2);
      case 'amount_no_decimals':
        return formatWithDelimiters(cents, 0);
      case 'amount_with_comma_separator':
        return formatWithDelimiters(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return formatWithDelimiters(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator':
        return formatWithDelimiters(cents, 2, "'", '.');
      case 'amount_no_decimals_with_space_separator':
        return formatWithDelimiters(cents, 0, ' ');
      case 'amount_with_space_separator':
        return formatWithDelimiters(cents, 2, ' ', ',');
      case 'amount_with_period_and_space_separator':
        return formatWithDelimiters(cents, 2, ' ', '.');
      default:
        return match;
    }
  });
}

const formatPrice = function(cents) {
  return shopifyFormatCurrency(cents, window.themeVariables.settings.moneyFormat);
}

function wrapFromPrice(formattedPrice, div) {
  if (div && div.dataset.datoraPriceVaries === 'true' && window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.fromPriceHtml) {
    return window.themeVariables.strings.fromPriceHtml.replace('_PRICE_', formattedPrice);
  }
  return formattedPrice;
}

// Hilfsfunktionen für Preisanzeige (EUR mit transcy-money span vs. andere Währungen mit Textknoten)
function setPriceText(container, price) {
  const visuallyHidden = container.querySelector('.visually-hidden');

  // Alles nach dem visually-hidden span entfernen
  while (visuallyHidden && visuallyHidden.nextSibling) {
    visuallyHidden.nextSibling.remove();
  }

  // Neuen Preis einfügen (kann HTML enthalten bei EUR/Transcy)
  if (visuallyHidden) {
    visuallyHidden.insertAdjacentHTML('afterend', price);
  } else {
    container.innerHTML = price;
  }
}

const applyDatoraDiscount = async function() {
  const datoraInput = document.querySelector('input[name="datora-discount"][form="datora-form"]') ||
                     document.querySelector('input[name="datora-discount"]');
  if(!datoraInput) return;
  const discountCode = datoraInput.value.trim();
  if(discountCode.length < 1){
    errorDatoraDiscount('show', 'empty');
    return;
  }
  const datoraContainer = datoraInput.closest('.datora-discount-field-container');
  errorDatoraDiscount('hide');
  if(datoraContainer) datoraContainer.classList.add('loading');

  if (typeof co2 === 'undefined') {
    if(datoraContainer) datoraContainer.classList.remove('loading');
    return;
  }

  const cleanInput = discountCode.trim().toUpperCase();
  const getCurrentDiscountCode = await co2.getDiscountCode();
  if(getCurrentDiscountCode && getCurrentDiscountCode.trim().toUpperCase() === cleanInput){
    if(datoraContainer) datoraContainer.classList.remove('loading');
    errorDatoraDiscount('show', 'double', discountCode);
    return;
  }

  const resultChangeDiscountCode = await co2.setDiscountCode(discountCode);
  if(resultChangeDiscountCode){
    refreshCartAndPrices();
    if (typeof restoreDiscountState === 'function') restoreDiscountState();
  } else {
    errorDatoraDiscount('show', 'failed', discountCode);
  }
  if(datoraContainer) datoraContainer.classList.remove('loading');
};

const removeDatoraDiscount = async function() {
  errorDatoraDiscount('hide');
  const datoraContainer = document.querySelector('.datora-discount-field-container');
  if(datoraContainer) datoraContainer.classList.add('loading');

  if (typeof co2 === 'undefined') {
    if(datoraContainer) datoraContainer.classList.remove('loading');
    return;
  }

  const resultRemoveDiscountCode = await co2.removeDiscountCode();
  if(resultRemoveDiscountCode){
    refreshCartAndPrices();
    document.querySelectorAll('.discounted[data-datora-price]').forEach(div => {
      resetProductGridDiscount(div);
    });
  }
  if(datoraContainer) datoraContainer.classList.remove('loading');
}

function setDatoraClasses(parentElem, fakeComparePrice) {
  const compare = parentElem.querySelector('.price-list .price--compare');
  if (compare && typeof setPriceText === 'function') {
    compare.classList.remove('hidden');
    setPriceText(compare, fakeComparePrice);
  }
}

// DATORACODE - A/B-Test (CFSN-620): Preisdarstellungs-Variante pro Element aus den Liquid-Klassen lesen —
// nur Opt-in-Flächen (PDP, Card, Predictive Search) tragen price--v620-*; alle anderen laufen den Standard-Pfad
function getAbPriceDisplayFor(div) {
  if (div.classList.contains('price--v620-inline')) return 'compare_inline';
  if (div.classList.contains('price--v620-twoline')) return 'compare_two_line';
  return 'standard';
}

// DATORACODE - A/B-Test (CFSN-620): Sale-Prozent aus dem Liquid-Attribut (identische Rundung in allen Kontexten);
// Fallback-Berechnung nur, falls das Attribut fehlt
function getSalePct(div) {
  const pct = parseInt(div.dataset.datoraSalePct || '', 10);
  if (!isNaN(pct)) return pct;
  const price = Number(div.dataset.datoraPrice);
  const compare = Number(div.dataset.datoraCompare || 0);
  // DATORACODE - A/B-Test (CFSN-620): gleiche Operationsreihenfolge wie Liquid ((C-P)*100/C) für identische Rundung
  return compare > price ? Math.round(((compare - price) * 100) / compare) : 0;
}

// DATORACODE - A/B-Test (CFSN-620): Badge-Text für B/C — nie mit Code-Name.
// B + Sale (Fall 3) kombiniert Sale-Prozent und Rabatt-Wert:
//   plus: -40% + 10% / -40% + €1,99 (Minus nur vor dem ersten Wert)
//   amp:  -40% & -10% / -40% & -€1,99 (Minus vor beiden Werten)
// Bei 0% Sale-Anteil (oder Variante C / Fall 4) nur der Rabatt-Wert.
function buildAbBadgeText(div, abDisplay, saleLayout, discStr) {
  const salePct = saleLayout ? getSalePct(div) : 0;
  if (abDisplay !== 'compare_inline' || salePct < 1) {
    return `<b>-${discStr}</b>`;
  }
  const fmt = window.themeSettings && window.themeSettings.abCfsn620PriceCombinedFormat;
  return fmt === 'amp'
    ? `<b>-${salePct}% &amp; -${discStr}</b>`
    : `<b>-${salePct}% + ${discStr}</b>`;
}

function errorDatoraDiscount(type = 'show', reason = 'invalid', code = '') {
  const cartDrawer = document.querySelector('cart-drawer');
  const datoraContainer = document.querySelector('.datora-discount-field-container');
  const errorDiv = datoraContainer ? datoraContainer.querySelector('.datora-discount-error') : null;
  if(type == "show"){
    let errorAlert = window.themeVariables?.strings?.[datoraErrorKeys[reason]] ?? false;
    if(!errorAlert) return;
    const cleanCode = code.trim().toUpperCase();
    errorAlert = errorAlert.replace("[[CODE]]",truncate(cleanCode,10));
    if(datoraContainer) datoraContainer.classList.add('error');
    if(errorDiv) errorDiv.style.display = 'block';
    if(reason == "empty"){
      if(datoraContainer) datoraContainer.querySelector('.datora-input input').focus();
    }else if(reason == "double" || reason == "invalid" || reason == "failed"){
      if(datoraContainer){
        const input = datoraContainer.querySelector('.datora-input input');
        const isActive = datoraContainer.getAttribute('data-discount-state') === 'active';
        if(isActive){
          if(typeof restoreDiscountState === 'function') restoreDiscountState();
        }else{
          input.value = '';
          input.classList.remove('is-filled');
        }
      }
    }
    if(datoraContainer) datoraContainer.querySelector('.datora-discount-error span').innerHTML = errorAlert;
  }else{
    if(cartDrawer) cartDrawer.classList.remove('error');
    if(datoraContainer) datoraContainer.classList.remove('error');
    if(errorDiv) errorDiv.style.display = '';
  }
}


// DATORACODE - CFSN-568 A/B-Test: Bild-Mirror-Slot zum Price-Badge-Host finden (Card / PDP / Cart-Upsell-Slider)
function getImageDiscountMirror(div){
  const root = div.closest('.product-card-wrapper, product-info, .simple-upsell__card, .stl-card');
  return root ? root.querySelector('[data-datora-image-mirror]') : null;
}

function resetProductGridDiscount(div){
  div.classList.remove('discounted');
  div.classList.remove('price--datora-loading');
  const oldPrice = div.dataset.datoraPrice;
  const oldCompare = div.dataset.datoraCompare;
  const oldCompareCheck = (oldCompare && oldCompare != "") ? parseInt(oldCompare) : 0;
  // DATORACODE - A/B-Test (CFSN-620): B/C setzen den Compare-Span immer in den Ausgangszustand (hidden) zurück —
  // die Streichpreis-Darstellung ohne Rabatt gehört dort dem Liquid-Markup (.price__sale)
  if (getAbPriceDisplayFor(div) !== 'standard') {
    const compare = div.querySelector('.price--compare');
    if (compare) compare.classList.add('hidden');
  } else if(oldCompareCheck == 0){
    const compare = div.querySelector('.price--compare');
    if (compare) compare.classList.add('hidden');
  }
  const basePriceFormatted = wrapFromPrice(formatPrice(oldPrice), div);
  const priceContainer = div.querySelector('.price-list .price:not(.price--compare)');
  if (priceContainer && typeof setPriceText === 'function') {
    setPriceText(priceContainer, basePriceFormatted);
  }
  const datoraInfo = div.querySelector('[data-datora]');
  if (datoraInfo) datoraInfo.textContent = '';
  const badge = div.querySelector('.datora.discount-badge');
  if (badge) badge.setAttribute('hidden', true);
  // DATORACODE - CFSN-568 A/B-Test: Bild-Mirror zurücksetzen
  const imageMirror = getImageDiscountMirror(div);
  if (imageMirror) {
    imageMirror.textContent = '';
    imageMirror.setAttribute('hidden', true);
  }
}

async function updateProductGridDiscounts(scope) {
  scope = scope || document;

  const discountCode = await co2.getDiscountCode();
  if (!discountCode) {
    scope.querySelectorAll('[data-datora-product-id]').forEach(function (el) {
      el.classList.remove('price--datora-loading');
      resetProductGridDiscount(el);
    });
    return;
  }

  for (const div of scope.querySelectorAll('[data-datora-product-id]')) {
    const vid = div.dataset.datoraVariantId;
    const pid = div.dataset.datoraProductId;
    const tags = div.dataset.datoraTags;
    const price = div.dataset.datoraPrice;
    const onSale = div.dataset.datoraSalePrice === 'true';

    if (!(vid && pid && price)) {
      div.classList.remove('price--datora-loading');
      continue;
    }

    try {
      const data = await co2.itemDiscountFull(Number(pid), Number(vid), tags ? tags.split(',') : [], Number(price), 1, false, onSale);
      div.classList.remove('price--datora-loading');

      if (!data) {
        resetProductGridDiscount(div);
        continue;
      }

      let validDisc = false;
      let newPrice, badgeText, imageBadgeText;

      /* DATORACODE - Compact-Flag: Badge ohne Rabattcode wenn data-datora-compact="true" */
      const compact = div.dataset.datoraCompact === 'true';

      // DATORACODE - A/B-Test (CFSN-620): Layout-Fall aus der Root-Klasse — price--on-sale bedeutet
      // "Sale und kein Volume-Pricing" (von Liquid berechnet, in B/C ohne hide_compare_prices-Gate)
      const abDisplay = getAbPriceDisplayFor(div);
      const saleLayout = abDisplay !== 'standard' && div.classList.contains('price--on-sale');

      if (data.calc === "perc" && data.discPerc > 0) {
        validDisc = true;
        newPrice = formatPrice(data.discPrice);
        // DATORACODE - CFSN-568: Bild-Badge immer kompakt (ohne Code), unabhängig vom Preis-Badge
        imageBadgeText = `<b>-${data.discPerc}%</b>`;
        if (abDisplay === 'standard') {
          badgeText = compact
            ? imageBadgeText
            : `<b>-${data.discPerc}%</b> (${discountCode.toUpperCase()})`;
        } else {
          // DATORACODE - A/B-Test (CFSN-620): B/C — Badge ohne Code-Name, in B Fall 3 kombiniert
          badgeText = buildAbBadgeText(div, abDisplay, saleLayout, `${data.discPerc}%`);
        }
      } else if (data.calc === "amt" && data.discAmt > 0) {
        validDisc = true;
        newPrice = formatPrice(data.discPrice);
        const discountValue = price - data.discPrice;
        imageBadgeText = `-${formatPrice(discountValue)}`;
        if (abDisplay === 'standard') {
          badgeText = compact
            ? imageBadgeText
            : `-${formatPrice(discountValue)} | ${discountCode.toUpperCase()}`;
        } else {
          badgeText = buildAbBadgeText(div, abDisplay, saleLayout, formatPrice(discountValue));
        }
      }

      if (validDisc) {
        div.classList.add('discounted');
        const priceContainer = div.querySelector('.price-list .price:not(.price--compare)');
        if (priceContainer && typeof setPriceText === 'function') {
          setPriceText(priceContainer, wrapFromPrice(newPrice, div));
        }
        if (abDisplay === 'compare_two_line' && saleLayout) {
          // DATORACODE - A/B-Test (CFSN-620): C Fall 3 — beide Streichpreise leben in Zeile 1 (.price__sale);
          // Compare-Span versteckt lassen (Guard gegen einen vorherigen Fall-4-Zustand nach Swatch-Wechsel)
          const compareEl = div.querySelector('.price-list .price--compare');
          if (compareEl) compareEl.classList.add('hidden');
        } else if (abDisplay === 'compare_inline' && saleLayout) {
          // DATORACODE - A/B-Test (CFSN-620): B Fall 3 — Streichpreis ist der compare_at-Preis statt des Originalpreises
          setDatoraClasses(div, formatPrice(Number(div.dataset.datoraCompare)));
        } else {
          const originalPriceAsComparePrice = formatPrice(price);
          setDatoraClasses(div, originalPriceAsComparePrice);
        }
        const datoraBadge = div.querySelector('[data-datora]');
        if (datoraBadge) datoraBadge.innerHTML = badgeText;
        const badge = div.querySelector('.datora.discount-badge');
        if (badge) badge.removeAttribute('hidden');
        // DATORACODE - CFSN-568 A/B-Test: gleichen Badge-Text aufs Produktbild spiegeln (kein zweiter API-Call)
        const imageMirror = getImageDiscountMirror(div);
        if (imageMirror) {
          imageMirror.innerHTML = imageBadgeText;
          imageMirror.removeAttribute('hidden');
        }
      } else {
        resetProductGridDiscount(div);
      }
    } catch (error) {
      console.error('[datora] discount error:', error);
      div.classList.remove('price--datora-loading');
      resetProductGridDiscount(div);
    }
  }
}

// ---------------------------------------------------------------------------
// Dawn theme integration
// ---------------------------------------------------------------------------

// DATORACODE - Expose for use in shop-the-look-slider.js
window.datoraUpdatePrices = updateProductGridDiscounts;

// Cart refresh via Dawn pub/sub (global.js bridge dispatches cart.update for co2)
function refreshCartAndPrices() {
  fetch(window.Shopify?.routes?.root + 'cart.js', { cache: 'reload' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'datora', cartData: cart });
    })
    .catch(function (e) {
      console.error('[datora] cart refresh error:', e);
    });
}

// Dawn pub/sub event subscriptions

subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
  window.dispatchEvent(new CustomEvent('cart.update', { detail: { cart: event.cartData } }));
  if (typeof restoreDiscountState === 'function') restoreDiscountState();
});

subscribe(PUB_SUB_EVENTS.variantChange, function () {
  if (typeof co2 === 'undefined') return;
  requestAnimationFrame(function () {
    updateProductGridDiscounts();
  });
});

window.addEventListener('co2.cart.initialized', function() {
  updateProductGridDiscounts();
  restoreDiscountState();
});

let autoDiscountChecked = false;
window.addEventListener('co2.cart.initialized', async function() {
  if (autoDiscountChecked) return;
  autoDiscountChecked = true;
  const settings = window.themeVariables?.settings;
  if (!settings?.autoDiscountEnabled || !settings?.autoDiscountCode) return;
  if (typeof co2 === 'undefined') return;
  const currentCode = await co2.getDiscountCode();
  if (currentCode) return;
  const success = await co2.setDiscountCode(settings.autoDiscountCode);
  if (success) {
    refreshCartAndPrices();
  }
});

window.datoraUpdatePrices = updateProductGridDiscounts;
